(function () {
    'use strict';

    angular
        .module('app')
        .controller('DeletedItemsListCtrl', DeletedItemsListCtrl);

    /**
     * @ngdoc controller
     * @name DeletedItemsListCtrl
     *
     * @description
     * Lists the deleted items for the tenancy
     */

    DeletedItemsListCtrl.$inject = [
        'WindowTitleService',
        'NavigationAidService'];

    function DeletedItemsListCtrl(
        WindowTitleService,
        NavigationAidService) {

        var vm = this;
        vm.close = close;
        vm.titleText = 'Recycle Bin';

        activate();

        function activate() {
            WindowTitleService.setTitle(vm.titleText);
        }

        function close() {
            NavigationAidService.goBack();
        }
    }
})();